export class TelemetryEnvelopeUpdateError extends Error {
  constructor(errCause: Error) {
    super('Failed to update telemetry event envelope.', { cause: errCause });
    this.name = 'TelemetryEnvelopeUpdateError';
  }
}
